document.querySelectorAll('[data-variant-picker]').forEach(select => {
  const form = select.closest('form');
  const scope = select.closest('.commerce-copy');
  if (!form || !scope) return;
  const button = form.querySelector('[data-add-button]');
  const price = scope.querySelector('[data-product-price]');
  const quantity = form.querySelector('input[name="quantity"]');
  function sync() {
    const option = select.selectedOptions[0];
    const available = !!option && !option.disabled && option.dataset.available === 'true' && Number(option.dataset.priceCents) > 0;
    if (button) {
      button.disabled = !available;
      button.textContent = available ? button.dataset.addLabel : button.dataset.unavailableLabel;
    }
    if (price) price.textContent = option && Number(option.dataset.priceCents) > 0 ? option.dataset.price : button?.dataset.unavailableLabel || '';
    if (quantity) {
      const maximum = option?.dataset.maxQuantity;
      if (maximum !== undefined && Number(maximum) >= 0) quantity.max = maximum;
      else quantity.removeAttribute('max');
      if (Number(maximum) > 0 && Number(quantity.value) > Number(maximum)) quantity.value = maximum;
    }
  }
  select.addEventListener('change', sync);
  sync();
});
